export default __webpack_public_path__ + "static/media/typescript-icon.a93c689e.png";